import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import BackButton from '../../components/atoms/BackButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import usageTypes from '../../constants/UsageType';
import SubmitButton from '../../components/atoms/SubmitButton';

const styles = {
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: '64px 48px',
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  detailTable: {
    width: '100%',
    marginTop: 45
  },
  tableCellItem: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    width: 200,
    fontWeight: 700
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD'
  },
  title: {
    fontSize: 24,
    fontWeight: 700
  },
  buttonsContainer: {
    marginTop: 45
  },
  breakLine: {
    whiteSpace: 'pre-line'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    addConfirm,
    taxTypes,
    reducedTaxMenuPrefix,
    shopName,
    previewImage,
    menuGenreName,
    getUsageTypeName,
    getMenuChildTypeName
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;

    return (
      <div className={classes.root}>
        <Typography className={classes.title}>メニュー追加の確認</Typography>
        <Table className={classes.detailTable}>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableCellItem}>用途</TableCell>
              <TableCell className={classes.tableCellData}>
                {getUsageTypeName(addConfirm.usageType)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>対象</TableCell>
              <TableCell className={classes.tableCellData}>
                {getMenuChildTypeName(addConfirm.menuChildType)}
              </TableCell>
            </TableRow>
            {addConfirm.menuChildType !== 4 && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗ID
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.shopId}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopName}
                  </TableCell>
                </TableRow>
              </>
            )}
            {addConfirm.usageType === USAGE_TYPE_MENU && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {(() => {
                      if (addConfirm.reducedTaxType === 'REDUCED') {
                        return reducedTaxMenuPrefix;
                      }
                      return '';
                    })()}
                    {addConfirm.menuName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー画像
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    <ImagePreview previewImage={previewImage} />
                  </TableCell>
                </TableRow>
              </>
            )}
            {addConfirm.usageType === USAGE_TYPE_COMBO ? (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  単価×発行枚数
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${parseInt(
                    addConfirm.priceCombo,
                    10
                  ).toLocaleString()}円ｘ${addConfirm.quantity}枚`}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell className={classes.tableCellItem}>価格</TableCell>
                <TableCell className={classes.tableCellData}>
                  {parseInt(addConfirm.price, 10).toLocaleString()}
                  {`円`}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>税区分</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.taxType &&
                addConfirm.taxType.toString() === 'DONATION'
                  ? taxTypes.map(item => {
                      if (item.id.toString() === 'INTERNAL') {
                        return item.name;
                      }
                      return '';
                    })
                  : taxTypes.map(item => {
                      if (
                        addConfirm.taxType &&
                        addConfirm.taxType.toString() === item.id.toString()
                      ) {
                        return item.name;
                      }
                      return '';
                    })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                軽減税率対象
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.reducedTaxType === 'REDUCED'}
                {(() => {
                  if (addConfirm.reducedTaxType === 'REDUCED') {
                    return '対象';
                  }
                  return '対象外';
                })()}
              </TableCell>
            </TableRow>
            {addConfirm.usageType === USAGE_TYPE_COMBO && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    付与無料枚数
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.quantityFree
                      ? `${addConfirm.quantityFree}枚`
                      : ''}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    おまけ
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCellData} ${classes.breakLine}`}
                  >
                    {addConfirm.quantityFreeDes}
                  </TableCell>
                </TableRow>
              </>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>ジャンル</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuGenreName}
              </TableCell>
            </TableRow>
            {addConfirm.usageType === USAGE_TYPE_MENU && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>説明</TableCell>
                <TableCell
                  className={`${classes.tableCellData} ${classes.breakLine}`}
                >
                  {addConfirm.description}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.tagStr}
              </TableCell>
            </TableRow>
            {addConfirm.usageType !== USAGE_TYPE_MENU && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {(() => {
                      if (addConfirm.reducedTaxType === 'REDUCED') {
                        return reducedTaxMenuPrefix;
                      }
                      return '';
                    })()}
                    {addConfirm.menuName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー画像
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    <ImagePreview previewImage={previewImage} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>説明</TableCell>
                  <TableCell
                    className={`${classes.tableCellData} ${classes.breakLine}`}
                  >
                    {addConfirm.description}
                  </TableCell>
                </TableRow>
              </>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用期間</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.expiration && addConfirm.expiration !== ''
                  ? `${addConfirm.expiration}日間`
                  : addConfirm.expirationEndDate}
              </TableCell>
            </TableRow>
            {addConfirm.usageType === USAGE_TYPE_COMBO && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用制限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.numberUsePerDay === 0 ? 'なし' : '1日1枚'}
                </TableCell>
              </TableRow>
            )}
            {addConfirm.usageType === USAGE_TYPE_VOUCHER && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用方法
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.menuLimitTotal === 1
                    ? '一円単位利用'
                    : '一枚単位利用'}
                </TableCell>
              </TableRow>
            )}
            {addConfirm.usageType !== USAGE_TYPE_COMBO && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  寄付設定
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.taxType === 'DONATION' ? '対象内' : '対象外'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.buttonsContainer}>
          <BackButton onClickAction={backAction} />
          <SubmitButton onClickAction={registerAction} btnText="追加" />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
